export default __webpack_public_path__ + "static/media/closeCircle.5fd538bd.svg";